// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__hzCG7","scrolled":"Navbar_scrolled__uPNVU","notscrolled":"Navbar_notscrolled__o2BAP","mobileheader":"Navbar_mobileheader__P4pfZ"};